import React from "react";
import { ChevronDown } from "lucide-react";
import type { LucideIcon } from "lucide-react";

type SidebarCollapsibleSectionProps = {
  title: string;
  collapsedTitle?: string;
  icon: LucideIcon;
  isTabActive: boolean;
  isOpen: boolean;
  sidebarCollapsed: boolean;
  isFirst?: boolean;
  onHeaderClick: () => void;
  childrenWhenExpanded: React.ReactNode;
};

export const SidebarCollapsibleSection: React.FC<SidebarCollapsibleSectionProps> = ({
  title,
  collapsedTitle,
  icon: Icon,
  isTabActive,
  isOpen,
  sidebarCollapsed,
  onHeaderClick,
  childrenWhenExpanded,
  isFirst = false,
}) => {
  return (
    <div className={`space-y-2 ${isFirst ? "" : "mt-2"}`}>
      <button
        type="button"
        title={sidebarCollapsed ? collapsedTitle ?? title : undefined}
        onClick={onHeaderClick}
        className={`w-full flex items-center gap-2 rounded-lg transition-colors ${
          sidebarCollapsed ? "justify-center p-2" : "px-3 py-2"
        } ${
          isTabActive
            ? "bg-blue-500/20 text-blue-600 dark:text-blue-400"
            : "text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-[#1C202F]/60 dark:hover:text-white"
        }`}
      >
        <Icon className="h-4 w-4 flex-shrink-0" />
        {!sidebarCollapsed && (
          <>
            <span className="flex-1 text-left text-xs">{title}</span>
            <ChevronDown
              className={`h-4 w-4 flex-shrink-0 transition-transform duration-200 ${isOpen ? "" : "-rotate-90"}`}
            />
          </>
        )}
      </button>
      {!sidebarCollapsed && isOpen ? (
        <div className="ml-4 space-y-2 border-l border-slate-300 pl-2 dark:border-slate-700/80">{childrenWhenExpanded}</div>
      ) : null}
    </div>
  );
};
